var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWrestling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 55.3,
    cy: 32.1,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.9,
    cy: 32.1,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.9,78.2l16.4-16.4l-17-17c-3.5-3.5-9.2-3.5-12.7,0L77.7,65.6L66.1,54h17.4c1.4,0,2.7-0.6,3.6-1.5l14.5-14.5 c2-2,2-5.3,0-7.3s-5.3-2-7.3,0l-13,13H47.6c-2.3,0-4.6,0.9-6.4,2.6L13,74.6h32.6l13.3-13.3l15.2,15.2c2,2,5.3,2,7.3,0l14.4-14.4 L111.9,78.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,79.7H10.3v22.6L0,112.6v14.5l19.1-19.1c0.9-0.9,1.5-2.2,1.5-3.6V90h28.3v33.4c0,2.8,2.3,5.1,5.1,5.1s5.1-2.3,5.1-5.1 V84.9C59.1,82,56.8,79.7,54,79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,77.5l-12.1-12.1l-25,25c-0.9,0.9-1.5,2.2-1.5,3.6v29.3c0,2.8,2.3,5.1,5.1,5.1c2.8,0,5.1-2.3,5.1-5.1V96.2L131.9,80 L144,92.1L144,77.5L144,77.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrestling);
export default __webpack_public_path__ + "static/media/wrestling.043a9d5407167c13d00499ed62d080fc.svg";
export { ForwardRef as ReactComponent };